<template>
  <component :is="componentName" @changeComponet="changeComponet"></component>
</template>
<script>
import redPacketList from './redPacketList';
import redPacketAdd from './redPacketAdd';
import redPacketView from './redPacketView';
import { mapQuery } from '@/utils/util';
export default {
  components: {
    redPacketList,
    redPacketAdd,
    redPacketView,
  },
  data() {
    return {
      componentName: 'redPacketList',
      id: null,
    };
  },
  watch: {
    $route: {
      handler(route) {
        const { componentName } = route.query;
        componentName
          ? (this.componentName = componentName)
          : (this.componentName = 'redPacketList');
      },
      // 深度观察监听
      immediate: true,
      deep: true,
    },
  },
  created() {
    const { componentName } = this.$route.query;
    componentName ? (this.componentName = componentName) : '';
  },
  methods: {
    changeComponet(componentName, query) {
      this.componentName = componentName;
      const url = `/saas/enterpriseRedPacket.html${mapQuery({ componentName, ...query })}`;
      this.g_tourl(url, {});
    },
  },
};
</script>
<style lang="scss" scoped></style>
